import React, { useState, useEffect } from 'react';
import { Link, } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Container, Button } from '@mui/material';
import log from '../images/TCL_logoFullColor1.png'

function Mynavbar() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userName, setUserName] = useState('');
  const [userId, setUserId] = useState('');
  // const history = useHistory();

  // Check if the user is authenticated on component mount
  useEffect(() => {
    const token = localStorage.getItem('calendar_admin');
    setIsAuthenticated(!!token); // Set isAuthenticated to true if token exists
    setUserName(localStorage.getItem('username'));
    // setUserId(localStorage.getItem('userId'));
  }, []);

  // Handle sign out
  const handleSignOut = () => {
    localStorage.removeItem('calendar_admin'); // Remove the token from localStorage
    localStorage.removeItem('username'); // Remove the token from localStorage
    localStorage.removeItem('admin_lvl'); // Remove the token from localStorage
    localStorage.removeItem('admin_user'); // Remove the token from localStorage
    localStorage.removeItem('userId'); // Remove the token from localStorage

    setIsAuthenticated(false); // Update authentication state
    // history.push('/signin'); // Redirect to the sign-in page
    window.location.reload();
  };

  return (
    <AppBar position="sticky" >
      <Container sx={{ backgroundColor: '#1976d2', padding: '0rem 0' }}>
        <Toolbar sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
          {/* Logo on the left */}
          <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
            {/* <img src={'/static/media/logo_square_transparent.1004592d60d4cdcec3d5.png'} alt="Logo" style={{ height: '3rem', marginRight: '10px' }} /> */}
            <img src={log} alt="Logo" style={{ height: '4rem', marginRight: '10px' }} />
          </Link>
          {/* Conditional rendering based on authentication */}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {isAuthenticated ? (
              <>
                <Typography variant="body1" sx={{ marginRight: 2, fontWeight: 'bold', color: 'white' }}>
                  {userName}
                </Typography>
                <Button
                  variant="outlined"
                  color="inherit" // Change to inherit to match the navbar color
                  onClick={handleSignOut}
                  sx={{
                    borderRadius: '20px',
                    padding: '8px 16px',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.15)', // Slight hover effect
                    },
                  }}
                >
                  Sign Out
                </Button>
              </>
            ) : (
              <>
                <Link to="/signin" style={{ textDecoration: 'none' }}>
                  <Button
                    variant="contained"
                    color="inherit" // Change to inherit to match the navbar color
                    sx={{
                      borderRadius: '20px',
                      marginRight: 2,
                      padding: '8px 16px',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.15)', // Slight hover effect
                      },
                    }}
                  >
                    Sign In
                  </Button>
                </Link>
                <Link to="/signup" style={{ textDecoration: 'none' }}>
                  <Button
                    variant="outlined"
                    color="inherit" // Change to inherit to match the navbar color
                    sx={{
                      borderRadius: '20px',
                      padding: '8px 16px',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.15)', // Slight hover effect
                      },
                    }}
                  >
                    Sign Up
                  </Button>
                </Link>
              </>
            )}
          </div>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Mynavbar;
